<template>
  <div>
    <v-layout row wrap>
      <v-flex xs6>
        <v-form ref="form" class="ma-1">
          
          <v-text-field
            type="number"
            step="1000"
            min="0"
            solo
            v-model="buyP"
            required
          >
          <template slot="prepend-inner"><b>Prix:</b>  </template>
          </v-text-field>
          <v-text-field
            type="number"
            step="0.0001"
            min="0"
            solo
            v-model="bidAmount"
          >
          <template slot="prepend-inner"><b class="caption" style="margin-left:-10px;">{{currencyUpperCase}} </b> </template>
          <template slot="append"><i class="caption" style="margin-right:-10px;">≈{{bidDollar}}$</i></template>
          </v-text-field>
          <v-text-field solo  v-model="bidTotal" >
            <template slot="prepend-inner"><b class="caption" style="margin-left:-10px;">Total</b> </template>
            <template slot="append"><i class="caption"><button class="btn-all" style="backgroundColor:#c3c3c3;" @click.prevent="tout">tout</button></i></template>
          </v-text-field>
          <v-btn 
            
            class="trade-btn-buy success"
            @click.prevent="submitBid"
            :loading="loadbid"
          >Acheter {{currencyUpperCase}} </v-btn>
          <p v-if="success" class="green--text">succes</p>
          <p v-if="show" class="red--text">solde insuffisant</p>
        </v-form>
      </v-flex>

      <v-flex xs6>
        <v-form ref="form" class="ma-1">
          <v-text-field type="number" min="0" solo v-model="sellP">
            <template slot="prepend-inner"><b>Prix</b> </template>
          </v-text-field>
          <v-text-field type="number" min="0" solo v-model="askAmount">
            <template slot="append"><i class="caption"> ≈{{askDollar}}$</i></template>
            <template slot="prepend-inner"><b class="caption" style="margin-left:-10px;">{{currencyUpperCase}}</b> </template>
          </v-text-field>
          <v-text-field solo v-model="askTotal" disabled>
            <template slot="prepend-inner" ><b class="caption" style="margin-left:-10px;">Total</b> </template>
          </v-text-field>
          <v-flex text-xs-right>
            <v-btn
            color="#86176e"
            class="trade-btn-sell white--text"
            @click.prevent="submitAsk"
            :loading="loadask"
          >Vente {{currencyUpperCase}}</v-btn>
          </v-flex>
          <p v-if="success2" class="green--text">succes</p>
          <p v-if="show2" class="red--text">solde insuffisant</p>
        </v-form>
      </v-flex>
    </v-layout>
    <!-- <div class="mx-auto" style="max-width: 180px;">
      <Dollar/>
    </div> -->
  </div>
</template>

<script>
import { mapState} from "vuex";
import axios from "axios";


export default {

  props: {
    asset: {
      type: String,
    },
    currency:{
      type:String
    },
     second:{
      type:String
    }
  },
  data() {
    return {
      fee: 0.015,
      show: false,
      show2: false,
      success: false,
      success2: false,
      loadbid: false,
      loadask: false,
        bidPrice: null,
        bidAmount: null,
        bidTotal: null,
        askPrice: null,
        askAmount: null,
        askTotal: null,
        buyP:null,
        sellP:null,
        bidDollar:null,
        askDollar:null,
      
    };
  },
computed: {
  currencyUpperCase() {
    return this.currency.toUpperCase()
  },
  ...mapState({
    p1(state,getters) {
        return getters["authfb/"+this.currency]
    },
    p2(state,getters) {
        return getters["authfb/"+this.second]
    },
    }),
},
    
  mounted () {
    this.$root.$on('clickBid', (bidPrice, bidAmount, bidTotal) => {

       axios.get('https://www.blockchain.com/ticker').then((res)=>{
        console.log(res);
       let btcPrice = Number(res.data.USD.last);

        if (typeof bidPrice == 'number') {
              this.sellP=(bidPrice / btcPrice-0.1).toFixed(2);
          }
        
      }
      );

    });

     this.$root.$on('clickAsk', (askPrice, askAmount, askTotal) => {

        axios.get('https://www.blockchain.com/ticker').then((res)=>{
        console.log(res);
        let btcPrice = Number(res.data.USD.last);

         if (typeof askPrice == 'number') {
             this.buyP=(askPrice / btcPrice+0.1).toFixed(2);
          }
      }
      );
    });
    
    this.$root.$on('prixCfa', (cfa) => {
      this.buyP=cfa.toFixed(2);
      this.sellP=cfa.toFixed(2);
    });
  },
watch: {
    buyP(newValue, oldValue) {
      this.debouncedTotalBid();
    },
    bidAmount(newValue, oldValue) {
      this.debouncedTotalBid();
    },
    sellP(newValue, oldValue) {
      this.debouncedTotalAsk();
    },
    askAmount(newValue, oldValue) {
      this.debouncedTotalAsk();
    },
  },
  created: function () {
    this.debouncedTotalBid = _.debounce(this.totalBid, 500);
    this.debouncedTotalAsk = _.debounce(this.totalAsk, 500);
  },
  methods: {
    tout(){
      let total=Math.round(Number(this.$store.getters["authfb/cfa"]))-1
      if (this.buyP>0) {

        axios.get('https://www.blockchain.com/ticker').then((res)=>{
        console.log(res);
        let btcPrice = Number(res.data.USD.last);

        let bp=Number(this.buyP*btcPrice)
        let arrondi=(Number(total)/((1+this.fee)*bp))*100000000
        arrondi=Math.round(arrondi)
        this.bidAmount=arrondi/100000000

      }
      );

      }
    },

     totalBid() {

       axios.get('https://www.blockchain.com/ticker').then((res)=>{
        console.log(res);
        let btcPrice = Number(res.data.USD.last);

        this.btcPrice=btcPrice;
        this.bidPrice=Number(this.buyP*btcPrice)
        this.bidDollar=(this.bidAmount*btcPrice).toFixed(2)
        this.bidTotal = Number(
        ((1 + this.fee) *
        this.bidPrice *
        this.bidAmount
      ).toFixed(1))
        
      }
      );

    },
    totalAsk() {

      axios.get('https://www.blockchain.com/ticker').then((res)=>{
        let btcPrice = Number(res.data.USD.last);

        this.btcPrice=btcPrice;
        this.askPrice=Number(this.sellP*btcPrice);
        this.askDollar=(this.askAmount*btcPrice).toFixed(2)
        this.askTotal = Number(
        ((1 - this.fee) *
        this.askPrice *
        this.askAmount
      ).toFixed(1)) 
      }
      );
    },

    async submitBid() {

      // swal("Erreur", "Module en maintenance, veuillez utiliser le SWAP", "error", {
      //       button: "ok!",
      //       });

      let base_url = this.base_url
        if (location.hostname === "localhost") {
            base_url = 'http://localhost:4000'
        }

        console.log(base_url);
        

    if (this.buyP >=300 && this.buyP <=900) {
        
        if (this.bidPrice && this.bidAmount&&this.bidTotal) {                  
        this.loadbid = true;
        if (Number(this.bidTotal) < this.p2) {
          let auth_token = await this.firebase_auth_token()
          this.success = true;
          this.$store.dispatch("order/bid",{
            asset:this.asset,
            currency:this.currency,
            second:this.second,
            bidPrice:Number(this.bidPrice),
            bidAmount:Number(this.bidAmount),
            bidTotal: Number((1+this.fee)*this.bidAmount*this.bidPrice),
            fee:Number(this.fee),
            auth_token,
            base_url
          } ).then(() => {
            setTimeout(() => {
              this.loadbid = false;
              this.success = false;
            }, 2000);
          });
        } else {
          this.show = true;
          setTimeout(() => {
            this.loadbid = false;
            this.show = false;
          }, 700);
         
        }
      }
        
      }else{
        
         swal("Erreur Prix", "le prix doit etre compris entre 300 et 800 le dollar", "error", {
            button: "ok!",
            });
      }
    },
    async submitAsk() {
      // swal("Erreur", "Module en maintenance, veuillez utiliser le SWAP", "error", {
      //       button: "ok!",
      //       });


      let base_url = this.base_url
        if (location.hostname === "localhost") {
            base_url = 'http://localhost:4000'
        }

       if (this.sellP >=300 && this.sellP <=900) {
        if (this.askPrice && this.askAmount&&this.askTotal) {
          let auth_token = await this.firebase_auth_token()
        this.loadask = true;
        if (Number(this.askAmount) <= this.p1) {
          this.$store.dispatch("order/ask",{
            asset:this.asset,
            currency:this.currency,
            second:this.second,
            askPrice:Number(this.askPrice),
            askAmount:Number(this.askAmount),
            askTotal: Number((1-this.fee)*this.askPrice*this.askAmount),
            fee:Number(this.fee),
            auth_token,
            base_url
          } ).then(() => {
            this.success2 = true;
            setTimeout(() => {
              this.loadask = false;
              this.success2 = false;
            }, 2000);
          });
        } else {
          this.show2 = true;
          setTimeout(() => {
            this.show2 = false;
            this.loadask = false;
          }, 1000);
        
        }
      }
        
      }else{
        
         swal("Erreur Prix", "le prix doit etre compris entre 300 et 900 le dollar", "error", {
            button: "ok!",
            });
      }

    },
  }
};
</script>

<style scoped>
.v-input__control{
  height: 20px !important;
}

button.btn-all{
    border:1px solid blue;
    border-radius: 3px;
    padding: 5px 8px;
    margin-right: -10px;
  }
</style>
